import { render, staticRenderFns } from "./product-select-modal-new.vue?vue&type=template&id=f0a2f078&scoped=true&"
import script from "./product-select-modal-new.vue?vue&type=script&lang=js&"
export * from "./product-select-modal-new.vue?vue&type=script&lang=js&"
import style0 from "./product-select-modal-new.vue?vue&type=style&index=0&id=f0a2f078&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a2f078",
  null
  
)

component.options.__file = "product-select-modal-new.vue"
export default component.exports